import { Traveler, UserType } from "types";
import { validateParams } from "../hookHelpers";
import { ResourceFetchOptions, useResource } from "../useResource";

export const useTraveler = (
    travelerId: string | undefined,
    params: any = null,
    options: ResourceFetchOptions<Traveler> = {},
) => {
    params = validateParams(params);
    const fetchParams = { ...params, private: true, type: UserType.TRAVELER };

    const response = useResource<Traveler>(["users", travelerId], fetchParams, options);
    return { ...response, traveler: response.data, isLoadingTraveler: response.isLoading };
};
